<template>
  <div class="wrapper">
    <div class="header-wrapper">
      <div class="header">活动处理</div>
      <div class="addManager">
        <Button class="bkcc-btn" @click="loadData">搜索</Button>
        <Button class="bkcc-btn" @click="searchReset">重置</Button>
      </div>
    </div>
    
    <div class="content">
      <Card>
        <i-form ref="searchForm" :model="query">
          <row :gutter="20">
            <i-col span="6">
              <form-item label="姓名" prop="createUser">
                <i-input
                  v-model="query.createUser"
                  clearable
                  placeholder="请填写姓名"
                />
              </form-item>
            </i-col>

            <i-col span="6">
              <form-item label="处理内容" prop="content">
                <i-input
                  v-model="query.content"
                  clearable
                  placeholder="请填写处理内容"
                />
              </form-item>
            </i-col>
            <i-col span="6">
              <form-item label="审核状态" prop="state">
                <Select v-model="query.state" style="width:100%" clearable>
                  <Option v-for="item in stateList" :value="item.value" :key="item.value">{{ item.name }}</Option>
                </Select>
              </form-item>
            </i-col>
          </row>
          
        </i-form>
      </Card>
      <Card class="card" style="margin-top: 20px">
        <Table border :columns="columns" :data="data" :loading="loading"></Table>
        <div class="page">
          <Page :total="total" :current="pageNum" @on-page-size-change="changePageSize" show-total :page-size="pageSize" :page-size-opts="[10,15,20,50,100,200]" @on-change="page" show-sizer/>
        </div>
      </Card>
    </div>
  </div>
</template>

<script>
var that;
import miment from "miment";
import { Page } from "view-design";
export default {
  components:{
    Page
  },
  data() {
    return {
      stateList:[{
          name:'待审核',
          value:1
        },
        {
          name:'审核完成',
          value:0
        }
      ],
      query: {
        createUser: "",
        content: "",
        state: "",
        // community:'',
        // communityId:''
      },
      communityList:[],
      columns: [
        {
          title: "序号",
          type: 'index',
          width: 70,
          align: 'center'
        },
        {
          title: "姓名",
          key: "createUser",
          width:110
        },
        {
          title: "社区",
          key: "communityName",
          width:160
        },
        {
          title: "处理内容",
          key: "content",
          width:380,
          render: (h, params) => {
              return h("Tooltip",{
                props: {
                    content:params.row.content,
                    placement: "top",
                    maxWidth:"800"
                },
              },[
                h("div", {
                    style: {
                        wordbreak: "break-all",
                        overflow: "hidden",
                        display: "-webkit-box",
                        WebkitLineClamp: "2",
                        WebkitBoxOrient: "vertical",
                        width: "100%",
                      }
                },params.row.content)
            ]);
          }
        },
        {
          title: "附件",
          key: "fileurl",
          render: (h, params) => {
            let imgList = params.row.fileurl ? params.row.fileurl.split(',') : [];
            let imgArr = [];
            for (let i = 0; i < imgList.length; i++) {
              imgArr.push(h("viewer",{},[
                h("img", {
                  style: {
                    "width": "60px",
                    "height": "60px",
                    "object-fit":"cover",
                    "margin-right": "10px"
                  },
                  attrs: {
                    src: imgList[i],
                    alt: "图片加载失败"
                  }
                })
              ]));
            }
            return h("div",
              {
                style: {
                  "display": "flex",
                  "align-items": "center"
                }
              },imgArr);
            }
        },
        {
          title: "提交时间",
          key: "createTime",
          width:160
        },
        {
          title: "修改时间",
          key: "updateTime",
          width:160
        },
        {
          title: "状态",
          key: "state",
          width:110,
          render:function(h, params) {
            return h("div",{
              style:{
                color:params.row.state==1 ? '' : 'rgb(0, 195, 255)'
              }
            },params.row.state==1 ? '待审核' : '审核成功')
          }
        },
        {
          title: "操作",
          width:100,
          render: function(h, params) {
            return h("div", [
              h(
                "Button",
                {
                  style: {
                    color: "#5e6d94"
                  },
                  props:{
                    disabled:params.row.state!=1,
                    type:"dashed"
                  },
                  on: {
                    click: () => {
                      that.audit(params);
                    }
                  }
                },
                "审核"
              ),
            ]);
          }
        }
      ],
      pageNum: 1,
      pageSize: 10,
      data:[],
      loading: true,
      total: 0,
    };
  },
  computed: {
    
  },
  methods: {
    communityChange(e){
      this.query.communityId = e.length==3 ? e[2].communityId : '';
    },
    getCommunity() {
      this.$get(this.urlobj.getCommunityCascade, {
        communityId: this.$store.state.streetorcommunityid,
        nationwide: 1,
      })
      .then((res) => {
        this.communityList = res.rows.length
          ? this.formateData(res.rows)
          : [];
        console.log(this.communityList);
      })
      .catch((e) => {
        this.$Message.error("获取行政区域失败");
      });
    },
    //处理行政区域数据
    formateData(data){
      let returnData = data.map(item => {
          return {
              value:{
                  communityId:item.communityId,
                  childrenIdList:item.childrenIdList,
              },
              label:item.communityName,
              children:item.children.length?this.formateData(item.children):[]
          }
      })
      return returnData;
    },
    audit(params){
      this.$Modal.confirm({
        title:'审核确认',
        content:`是否进行用户（${params.row.createUser}） 活动处理审核`,
        onOk: () => {
          this.auditRequest(params.row)
        }
      })
    },
    auditRequest(item){
      let url = this.urlobj.reviewProcessJczlActivityProcess;
      this.$get(url,{
        id:item.id,
        communityId:item.communityId,
        score:item.score,
      })
      .then(res => {
        if (res.isSucceed) {
          this.loadData();
        }else{
          this.$Modal.confirm({
            title: "提示",
            content: res.message
          });
        }
      })
    },
    searchReset(){
      this.pageNum = 1
      this.pageSize = 10
      this.$refs.searchForm.resetFields();
      this.loadData();
    },
    loadData(){
      this.loading = true
      let url = this.urlobj.getPcListJczlActivityProcess;
      let params = JSON.parse(JSON.stringify(this.query))
      delete params.community
      var data = { 
        page: this.pageNum,
        rows: this.pageSize,
        ...params
      };
      this.$get(url,data)
      .then(res => {
        this.data = res.rows.map(item=>{
          return {
            ...item,
            createTime:miment(item.createTime).format("YYYY-MM-DD hh:mm"),
            updateTime:miment(item.updateTime).format("YYYY-MM-DD hh:mm"),
          }
        })
        this.total = res.total
        if (!res.isSucceed) {
          this.$Modal.confirm({
            title: "提示",
            content: res.message
          });
        }
        this.loading=false
      })
      .catch(e => {
        console.error(e)
        this.loading=false
      })
    },

    changePageSize(val){
      this.pageSize = val
      this.loadData()
    },
    page(val) {
      this.pageNum = val;
      this.loadData()
    },
    
  },
  mounted() {
    this.loadData()
  },
  created() {
    that = this;
    // this.getCommunity()
  }
};
</script>
<style lang='less' scoped>
.wrapper {
  color: #666666;
  height: 100%;
}

.wrapper::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
  /* height: 4px; */
}
.header-wrapper {
  display: flex;
  justify-content: center;
  height: 84px;
  line-height: 84px;
  position: relative;
}
.header {
  font-size: 25px;
  text-align: center;
}
.addManager {
  position: absolute;
  right: 20px;
}
.content {
  //   @content();
  // max-width: 96%;
  margin: 20px;
  margin-top: 0;
  // background: #fff;
  // padding: 0 15px 0 15px;
  &::-webkit-scrollbar {
    display: none;
  }
  .select-wrapper {
    font-size: 16px;
    margin-bottom: 20px;
    .name {
      margin-bottom: 10px;
    }
    .input {
      width: 30%;
    }
  }
  .card {
    height: 100%;
  }
  /deep/ .ivu-table-overflowX {
    overflow-x: hidden !important;
  }
}
.search {
  width: 100%;
  background-color: white;
  border-radius: 5px;
  padding: 20px;
}
.table-tabs {
  max-width: 100%;
  padding: 0;
  margin-top: 30px;

  /deep/ .ivu-tabs-bar {
    margin-bottom: 0;
    border-bottom: 0;
  }
  /deep/ .ivu-tabs-tab-active {
    color: white;
    background: #fe7d43;
    border-radius: 5px 5px 0 0;
  }
  /deep/ .ivu-tabs-ink-bar {
    height: 0px;
  }
  /deep/ .ivu-tabs-nav {
    padding-left: 10px;
    color: black;
  }
}

.table-data {
  width: 100%;
  background-color: white;
  border-radius: 5px;
  padding: 20px;
  min-height: calc(100vh - 450px);
}
.page {
  width: 100%;
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
}
.code-img {
  margin: 20px auto;
  display: flex;
  align-items: center;
  justify-content: center;
  // width: 172px;
  height: 172px;
  img {
    width: 172px;
    height: 172px;
  }
}
.text {
  font-size: 16px;
  span {
    text-decoration: underline;
    color: #fe7d43;
  }
}
/deep/ .ivu-table-tip table td{
  width: 100% !important;
}
/deep/ th .ivu-table-cell span {
  font-weight: bold !important;
}
</style>